export default __webpack_public_path__ + "static/media/DSC03382.f96308df.JPG";